import { Button, Descriptions, Modal } from 'antd';
import { useState } from 'react';
import { CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment } from '../../../../../../generated';
import { JsonView, allExpanded } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { FormatDate } from '../../../../../../constants';

interface HeaderDetailProps {
  isArchived?: boolean;
  data: CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment;
}

export const HeaderDetail: React.FC<HeaderDetailProps> = (props) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleDownloadClick = () => {
    setModalVisible(true);
  };

  function removeTypename(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(removeTypename);
    } else if (obj && typeof obj === 'object') {
      const { __typename, ...rest } = obj;
      return Object.fromEntries(Object.entries(rest).map(([key, value]) => [key, removeTypename(value)]));
    }
    return obj;
  }

  const handleDownloadJSONClick = () => {
    const anchor = document.createElement('a');
    anchor.href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(removeTypename(props?.data), null, 2))}`;
    anchor.download = 'archived-case-details.json';
    anchor.click();
    setModalVisible(false);
  };

  return (
    <div className="mt-2">
      <Descriptions layout="vertical" column={6}>
        <Descriptions.Item label="Decision Date">
          {props.data?.caseDetails?.applicationReview?.decision?.completedAt
            ? FormatDate(props.data?.caseDetails?.applicationReview?.decision?.completedAt)
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Decision">{props.data?.caseDetails?.applicationReview?.decision?.result}</Descriptions.Item>
        <Descriptions.Item label="Approval By">{props.data?.caseDetails?.applicationReview?.decision?.completedBy?.displayName ?? "SYSTEM"}</Descriptions.Item>
        <Descriptions.Item label="">{''}</Descriptions.Item>
        <Descriptions.Item label="">{''}</Descriptions.Item>
        <Descriptions.Item>
          <Button type="primary" onClick={handleDownloadClick}>
            View Full Case Details
          </Button>
        </Descriptions.Item>
      </Descriptions>

      <Modal title="Full Archived Case Details" open={modalVisible} footer={null} onCancel={() => setModalVisible(false)}>
        <pre>
          <JsonView data={removeTypename(props?.data)} shouldExpandNode={allExpanded} />
        </pre>
        <Button type="primary" onClick={() => handleDownloadJSONClick()}>
          Download
        </Button>
      </Modal>
    </div>
  );
};
